import { render } from "./ActiveButton.vue?vue&type=template&id=7e8eec46"
import script from "./ActiveButton.vue?vue&type=script&lang=js"
export * from "./ActiveButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__